import React, { useContext, useEffect, useState } from "react";
import { MyContext } from "../../context/Context";
import ScaleLoader from "react-spinners/ScaleLoader";
import moment from "moment";
import { urlLinks } from "../../UrlLinks";
import axios from "axios";

const JobCard = (props) => {
  const { keyId, data, selectedTab, selectedFilterOption } = props;
  const { selectedOption, loading, setLoading, onboardToken } =
    useContext(MyContext);
  const [earnValue, setEarnValue] = useState(0);
  const [logo, setLogo] = useState(selectedOption.logo);
  const [taskId, setTaskId] = useState("");
  const [dateValue, setDateValue] = useState(null);
  const [stageDueDate, setStageDueDate] = useState({
    tat: null,
    colour: "",
  });
  const [cardStatus, setCardStatus] = useState("");
  const [qcStatus, setQcStatus] = useState("");

  const getDueDate = (date) => {
    // Set time to 23:59:0:0
    const updatedDate = moment(date).set({
      hour: 23,
      minute: 59,
      second: 0,
      millisecond: 0,
    });

    // Get the current date
    const now = moment();

    // Calculate the duration between now and the updated date
    const duration = moment.duration(updatedDate.diff(now));

    // Extract days and hours from the duration
    const days = Math.floor(duration.asDays()); // Get whole days
    const hours = duration.hours(); // Get the remaining hours

    // Determine if the date is in the future or overdue
    const isFuture = duration.asMilliseconds() > 0;
    const colorStatus = isFuture && duration.asHours() > 24 ? "blue" : "red";

    // Format the result string
    const result = `${Math.abs(days)} day${
      Math.abs(days) !== 1 ? "s" : ""
    } ${Math.abs(hours)} hr${Math.abs(hours) !== 1 ? "s" : ""} ${
      isFuture ? "left" : "overdue"
    }`;
    setStageDueDate({ tat: result, colour: colorStatus });
  };

  const getCardStatus = (name, type, value) => {
    if (selectedTab.id === "Open") {
      let isDrafted = 0;

      if (name === "is_draft" && type === "string" && value === "1") {
        isDrafted = 1;
        setCardStatus("Draft");
      } else if (name === "is_tat_expired" && type === "boolean" && value) {
        isDrafted = 1;
        setCardStatus("Overdue");
      } else if (
        name === "entityStage" &&
        type === "string" &&
        isDrafted === 0 &&
        value === "REWK"
      ) {
        setCardStatus("Rework");
      }
    } else {
      if (
        name === "entityStage" &&
        type === "string" &&
        (value === "SBMT" || value === "QCD" || value === "QCAL")
      ) {
        setCardStatus("QC Pending");
      }
    }
  };

  const getFormUrl = (stepProgressData) => {
    let formUrl = `${urlLinks.baseUrlTask}${urlLinks.taskExecution.tasks}/${stepProgressData.id}?userId=${onboardToken.email}&pass=${onboardToken.password}&source=task-app`;
    window.open(formUrl, "_blank");
  };

  const handleStart = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.get(
        `${urlLinks.baseUrlTask}${urlLinks.taskExecution.step_progress}?processDefinitionId=${data.processDefinitionId}&processInstanceId=${data.id}&processDefinitionKey=${selectedOption.process_def_key}`,
        {
          headers: {
            Authorization: `${onboardToken.authCode}`, // Adding the Authorization header
          },
        }
      );
      let stepProgressData = response.data.data.current[0];
      getFormUrl(stepProgressData);
    } catch (error) {
      console.log("error", error);
    }
  };

  useEffect(() => {
    setLoading(true);
    data?.variablesModified?.forEach((e) => {
      let formattedDate = null;

      if (
        (e.name === "final_value" && e.value !== "") ||
        (e.name === "ratecard_value" && e.value !== "")
      ) {
        setEarnValue(e.value);
      }
      if (e.name === "logo" && e.value && e.value !== "") {
        setLogo(e.value);
      }
      if (e.name === "caseNumber") {
        setTaskId(e.value);
      }
      if (selectedTab.id === "Open") {
        if (e.name === "wf_assigned_on" && e.type === "date" && e.value) {
          formattedDate = moment(e.value).format("DD/MM/YYYY");
          setDateValue(formattedDate);
        }
        if (e.name === "stage_due_date" && e.type === "date" && e.value) {
          getDueDate(e.value);
        }
        getCardStatus(e.name, e.type, e.value);
      } else if (selectedTab.id === "Submitted") {
        if (e.name === "wf_submitted_on" && e.type === "date" && e.value) {
          formattedDate = moment(e.value).format("DD/MM/YYYY");
          setDateValue(formattedDate);
        }
        getCardStatus(e.name, e.type, e.value);
      } else if (selectedTab.id === "QcDone") {
        if (e.name === "qc_submitted_on" && e.type === "date" && e.value) {
          formattedDate = moment(e.value).format("DD/MM/YYYY");
          setDateValue(formattedDate);
        }
        if (selectedFilterOption === "Approved") {
          if (e.name === "admin_qc" && e.type === "string" && e.value !== "") {
            setQcStatus(e.value);
          } else if (e.name === "qc" && e.type === "string" && e.value !== "") {
            setQcStatus(e.value);
          }
        } else {
          if (
            e.name === "reject_reason" &&
            e.type === "string" &&
            e.value !== ""
          ) {
            setQcStatus(e.value);
          }
        }
      }
    });
    setLoading(false);
  }, [data, selectedTab]);

  const loaderBar = (
    <div key={keyId} className="my-[130px] mx-auto flex justify-center">
      <ScaleLoader height={70} width={10} color={"#1c75bc"} />
    </div>
  );

  const updatedDateLayout = (
    <p className="text-[#686868] text-[10px] font-medium italic ">
      {selectedTab.id === "Open"
        ? "Asssigned on"
        : selectedTab.id === "Submitted"
        ? "Submitted on"
        : "Approved on"}{" "}
      {dateValue}
    </p>
  );

  const taskIdLayout = (
    <p className="flex text-[#757575] text-[10px] uppercase">
      Task ID :&nbsp;
      <span className="text-[#2E2E2E] text-[10px] font-medium">{taskId}</span>
    </p>
  );

  const dueDateLayout = (
    <p
      className={`text-[10px] font-medium border-[0.4px] ${
        stageDueDate.colour === "blue"
          ? "text-[#1C75BC] border-[#1C75BC] bg-[#E6F1F9]"
          : "text-[#E81D1D] border-[#E81D1D] bg-[#FFEFEF]"
      } rounded-[4px] text-center mt-[7px]`}
    >
      {stageDueDate.tat}
    </p>
  );

  const cardStatusLayout = (
    <div
      className={`border-[0.4px] rounded-[28px] h-[22px] flex text-[12px] justify-center items-center px-[10px] ${
        cardStatus === "Rework"
          ? "border-[#E81D1D] bg-[#FFEFEF]"
          : "border-[#EC0] bg-[#FFF9D8]"
      }`}
    >
      {cardStatus}
    </div>
  );

  const tableLayout = data?.variablesModified?.map(
    (el, index) =>
      el.rowName &&
      el.name !== "admin_qc" &&
      el.name !== "qc" &&
      el.name !== "reject_reason" && (
        <div
          key={index}
          className={`flex text-[12px] text-[#757575] px-[10px] py-[5px]`}
        >
          <div className="text-[#757575] min-w-[100px]">{el.rowName}</div>
          :&nbsp;&nbsp;&nbsp;&nbsp;
          <div className="text-[#2E2E2E]">{el.value}</div>
        </div>
      )
  );

  const qcStatusLayout = (
    <div className="flex text-[12px] text-[#757575] bg-[#F4F4F4] rounded-bl-[9px] rounded-br-[9px] p-[10px]">
      <div className="text-[#757575] min-w-[100px]">
        {selectedFilterOption === "Approved" ? "QC Status" : "Rejected Reason"}
      </div>
      :&nbsp;&nbsp;&nbsp;&nbsp;
      <div className="text-[#2E2E2E]">{qcStatus}</div>
    </div>
  );

  const openTabExtraLayout = (
    <div className="flex pt-[10px] justify-between items-center p-[10px]">
      {cardStatus ? cardStatusLayout : <div></div>}
      <div className="flex items-center justify-between w-[60%]">
        {!!earnValue ? (
          <div className="text-[#30BF00] text-[14px] font-bold">
            Earn upto : {earnValue}
          </div>
        ) : (
          <div></div>
        )}
        <a
          href="www.google.com"
          onClick={handleStart}
          className="text-[14px] text-[#FFFFFF] py-[6px] px-[18px] rounded-[4px] bg-[#1C75BC] inline-block"
        >
          Start
        </a>
      </div>
    </div>
  );

  return loading ? (
    loaderBar
  ) : (
    <div
      key={keyId}
      className="border border-[#E0E0E0] rounded-[10px] mt-[16px] w-[328px]"
    >
      <div className="flex justify-between p-[10px] pb-[0]">
        <div className="rounded-[50%] w-[38px] h-[38px] border-2 border-[#F1F1F1] my-[auto]">
          <img src={logo} alt="logo" />
        </div>
        <div className="max-w-[150px]">
          <p className="text-[#2E2E2E] text-[12px] font-bold ">
            {data.processDefinitionName}
          </p>
          {dateValue && updatedDateLayout}
        </div>
        <div>
          {taskId && taskIdLayout}
          {selectedTab.id === "Open" && stageDueDate.tat
            ? dueDateLayout
            : selectedTab.id === "Submitted" && cardStatus
            ? cardStatusLayout
            : ""}
        </div>
      </div>
      <div className="mt-[10px]">
        {tableLayout}
        {selectedTab.id === "QcDone" && qcStatusLayout}
      </div>
      {selectedTab.id === "Open" && openTabExtraLayout}
    </div>
  );
};

export default JobCard;
